"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppDBError = void 0;
var generic_type_guard_1 = require("generic-type-guard");
exports.isAppDBError = new generic_type_guard_1.IsInterface()
    .withProperty('status', generic_type_guard_1.isNumber)
    .withProperty('statusReason', generic_type_guard_1.isString)
    .withProperty('toe', (0, generic_type_guard_1.isOptional)(generic_type_guard_1.isString))
    .get();
